import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
// Shared primary waitlist call-to-action. The waitlist destination
// (/signup?waitlist=1) renders a heavy screen before the waitlist popup
// appears, so a plain link feels unresponsive on click. This wrapper shows an
// immediate in-button loading state the moment it's pressed, then navigates on
// the next frame so the spinner has a chance to paint — making the CTA feel
// instant and intentional instead of broken.
type WaitlistCTAProps = {
  children: React.ReactNode;
  className?: string;
  to?: string;
  ariaLabel?: string;
  // Spinner tint — match the button's foreground (defaults to white for the
  // solid orange buttons; pass a dark value for light/ghost buttons).
  spinnerClassName?: string;
};
export function WaitlistCTA({
  children,
  className = '',
  to = '/signup?waitlist=1',
  ariaLabel,
  spinnerClassName = 'text-white'
}: WaitlistCTAProps) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleClick = () => {
    if (loading) return;
    setLoading(true);
    // Defer navigation a frame so the loading state paints before the heavy
    // destination screen blocks the main thread.
    window.requestAnimationFrame(() => {
      window.setTimeout(() => navigate(to), 0);
    });
  };
  return <button type="button" onClick={handleClick} disabled={loading} aria-label={ariaLabel} aria-busy={loading} className={`relative ${className} ${loading ? 'cursor-wait' : ''}`} data-id="element-3099">
      {/* Keep the original content in place (so the button keeps its exact
         size) but fade it out while the spinner overlays it. */}
      <span className={`inline-flex items-center justify-center gap-2 transition-opacity duration-150 ${loading ? 'opacity-0' : 'opacity-100'}`} data-id="element-3100">
        {children}
      </span>
      {loading && <span className="absolute inset-0 flex items-center justify-center" data-id="element-3101">
          <Loader2 size={20} className={`animate-spin ${spinnerClassName}`} data-id="element-3102" />
        </span>}
    </button>;
}